import React from 'react';
import {OfferFormSelectionProvider, OfferRequest, OfferRequestPartial} from "../OfferForm";
import styles from "../OfferForm.module.css";
import {ValidationResult} from "../../../../../elements/validator/component/ValidationComponent";
import {NotEmptyStringValidator} from "../../../../../elements/validator/Validator";
import {Section} from "../../../../../elements/section/Section";
import {useAppSelector} from "../../../../../../app/hooks";
import {OfferType} from "../../../../../../api/generated";
import {ValidatedSelectField} from "../../../../../elements/validator/component/ValidatedSelectField";
import {allOfferTypeOptions} from "./util/offerTypeUtil";
import {OfferWithDiscountFields} from "./fields/OfferWithDiscountFields";
import {OfferWithFinanceInfoFields} from "./fields/OfferWithFinanceInfoFields";

interface Props<T> {
    getMessage: (s: any) => any;
    updateRequest: (update: OfferRequestPartial) => void;
    selectionProvider: OfferFormSelectionProvider;
    updateValidationStatus: (status: ValidationResult<T>) => void;
}

export const SpecificOfferInformation = <T extends OfferRequest>({
                                                                     getMessage,
                                                                     updateRequest,
                                                                     selectionProvider,
                                                                     updateValidationStatus,
                                                                 }: Props<T>) => {

    const offerType = useAppSelector(selectionProvider.offerType)

    const getRequiredFields = () => {
        switch (offerType) {
            case OfferType.UsedVehicle:
            case OfferType.Service:
                return <OfferWithDiscountFields
                    getMessage={getMessage}
                    updateRequest={updateRequest}
                    selectionProvider={selectionProvider}
                    updateValidationStatus={updateValidationStatus}
                />
            case OfferType.NewVehicle:
                return <OfferWithFinanceInfoFields
                    getMessage={getMessage}
                    updateRequest={updateRequest}
                    selectionProvider={selectionProvider}
                    updateValidationStatus={updateValidationStatus}
                />
            default:
                return <></>
        }
    }

    return <Section title={"Specific Information"}>
        <div className={styles.fieldsLine}>
            <ValidatedSelectField<OfferType, T>
                onChange={(v) => updateRequest({offerType: v})}
                updateValidationStatus={updateValidationStatus}
                fieldName={'offerType'}
                selector={selectionProvider.offerType}
                validator={NotEmptyStringValidator}
                label={'Offer Type'}
                getMessage={getMessage}
                options={allOfferTypeOptions}
            />
        </div>
        {getRequiredFields()}
    </Section>
}
